// Automotive-themed animation configuration

export const easings = {
  // Quick start, smooth landing - like a car accelerating then cruising
  automotive: [0.25, 0.1, 0.25, 1.0] as const,
  // Snappy response - like quick gear changes
  aggressive: [0.4, 0.0, 0.2, 1.0] as const,
  // Smooth reveals - like a luxury car gliding
  cruise: [0.0, 0.0, 0.2, 1.0] as const,
  // Bounce effect - like suspension settling
  bounce: [0.68, -0.55, 0.265, 1.55] as const,
};

export const durations = {
  fast: 0.25,
  normal: 0.4,
  slow: 0.6,
  stagger: 0.08,
  kenBurns: 8,
};

export const springConfigs = {
  // Responsive and snappy
  snappy: { stiffness: 400, damping: 30 },
  // Gentle and smooth
  gentle: { stiffness: 200, damping: 20 },
  // Bouncy feel
  bouncy: { stiffness: 300, damping: 15 },
};
